import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { UserNotifyEvent } from '../../lib/userNotify';
import BetWonToast from './BetWonToast';
import './NotifyToastHost.css';

const TOAST_DURATION_MS = 9000;
const MAX_VISIBLE = 3;

type ToastEntry = {
  event: UserNotifyEvent;
  key: string;
};

let dispatchRef: ((event: UserNotifyEvent) => void) | null = null;

export function dispatchUserNotify(event: UserNotifyEvent): void {
  dispatchRef?.(event);
}

export const NotifyToastHost: React.FC = () => {
  const navigate = useNavigate();
  const [toasts, setToasts] = useState<ToastEntry[]>([]);

  const removeToast = useCallback((key: string) => {
    setToasts((prev) => prev.filter((t) => t.key !== key));
  }, []);

  const addToast = useCallback((event: UserNotifyEvent) => {
    if (event.type !== 'bet_won') return;
    const key = event.id;
    setToasts((prev) => {
      const next = [{ event, key }, ...prev.filter((t) => t.key !== key)];
      return next.slice(0, MAX_VISIBLE);
    });
  }, []);

  useEffect(() => {
    dispatchRef = addToast;
    return () => {
      dispatchRef = null;
    };
  }, [addToast]);

  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((t) =>
      setTimeout(() => removeToast(t.key), TOAST_DURATION_MS)
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, removeToast]);

  const goToBets = () => navigate('/today-bets');

  if (toasts.length === 0) return null;

  return (
    <div className="notify-toast-host" aria-live="polite">
      {toasts.map((t) => (
        <BetWonToast
          key={t.key}
          event={t.event}
          onClick={goToBets}
          onDismiss={() => removeToast(t.key)}
        />
      ))}
    </div>
  );
};
